import http from "common/http/createHttp";

const moveItemsToOrder = (sourceOrderId: string, targetOrderId: string) => {
  return http.post(`customer/orders/move?sourceOrderId=${sourceOrderId}&targetOrderId=${targetOrderId}`, {});
};

export default {
  moveItemsToOrder
};
